import { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { nikeoneClient } from '../../../common/axios/nikeoneClient';
import { ScoreboardType } from '../dto';
import { fromJS } from 'immutable';
import { ReframeEventHandler } from '../../../types/reframe';
import { keyBy } from 'lodash';
import { allScoreboardTypes$ } from '../push/overview/subs';

export function useScoreboardTypes() {
    const derefSub = useReframe();
    const loaded = derefSub(allScoreboardTypes$);
    useEffect(() => {
        if (loaded) return;
        nikeoneClient
            .get<never, ScoreboardType[]>('/v1/scoreboard_types')
            .then(scoreboardTypes => dispatch(scoreboardTypesLoaded(scoreboardTypes)));
    }, [loaded]);
}

const scoreboardTypesLoaded: (data: ScoreboardType[]) => ReframeEventHandler = data => db => {
    return db.setIn(['turboLive', 'scoreboardTypes'], fromJS(keyBy(data, 'scoreboardTypeId')));
};
